import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'isgcore-page-not-authorized',
  templateUrl: './page-not-authorized.component.html',
  styleUrls: ['./page-not-authorized.component.scss'],
  standalone: true
})
export class PageNotAuthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
